import { ClickAwayListener, Popover } from "@mui/material";
import {
  Box,
  GKButton,
  GKModal,
  GKTextField,
  Grid2,
  Typography,
  UpIcon,
} from "components";
import { useEffect, useState } from "react";

interface RationaleModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (rationale: string, sendForExecution: boolean) => void;
}

const RationaleModal = ({ open, onClose, onSelect }: RationaleModalProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [rationale, setRationale] = useState("");

  useEffect(() => {
    if (open) {
      setRationale("");
      setAnchorEl(null);
    }
  }, [open]);

  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleSelect = (sendForExecution: boolean) => {
    setAnchorEl(null);
    onSelect(rationale.trim(), sendForExecution);
  };

  return (
    <>
      <GKModal
        modalTitle="Place Order"
        open={open}
        setOpen={onClose}
        width="560px"
        footer={
          <Grid2
            container
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <GKButton variant="outlined" color="dark" onClick={onClose}>
              Cancel
            </GKButton>
            <GKButton
              variant="contained"
              onClick={handleClick}
              endIcon={
                <UpIcon
                  height={16}
                  width={16}
                  style={{
                    transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "transform 0.3s",
                    marginRight: 4,
                  }}
                />
              }
            >
              Place Order
            </GKButton>
          </Grid2>
        }
      >
        <Grid2 container spacing={3}>
          <Grid2 size={12}>
            <Typography mb={0.5}>Rationale</Typography>
            <GKTextField
              multiline
              minRows={4}
              maxRows={6}
              placeholder="Enter rationale..."
              value={rationale}
              onChange={(e) => setRationale(e.target.value)}
            />
          </Grid2>
        </Grid2>
      </GKModal>

      {isOpen && (
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Popover
            open={isOpen}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            slotProps={{ paper: { sx: { width: "180px", zIndex: 9999 } } }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Box
              sx={{
                bgcolor: "background.paper",
                border: "solid 1px var(--neutral-100)",
                borderRadius: "10px",
                boxShadow: "0px 0px 5px 4px var(--primary-50)",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: "8px 0",
              }}
            >
              <GKButton
                sx={{ color: "#333" }}
                onClick={() => handleSelect(false)}
              >
                Send Order Sheet
              </GKButton>
              <GKButton
                sx={{ color: "#333" }}
                onClick={() => handleSelect(true)}
              >
                Send for Execution
              </GKButton>
            </Box>
          </Popover>
        </ClickAwayListener>
      )}
    </>
  );
};

export default RationaleModal;
